export default __webpack_public_path__ + "static/android-chrome-192x192-12c784dd4bb7fa52ffccc02a40f60f81.png";